import { render, staticRenderFns } from "./userimage.html?vue&type=template&id=2247b6ad&scoped=true&external"
import script from "./userimage.js?vue&type=script&lang=js&external"
export * from "./userimage.js?vue&type=script&lang=js&external"
import style0 from "./userimage.scss?vue&type=style&index=0&id=2247b6ad&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2247b6ad",
  null
  
)

export default component.exports